import * as styles from './ControlSpacer.module.css'

import React from 'react'

interface Props {}

export const ControlSpacer: React.FC<Props> = () => {
  return <div className={styles.container}></div>
}
